<template>
    <v-fragment>
        <cart-header></cart-header>

        <cart-items></cart-items>

        <!--        <cart-calculation></cart-calculation>-->

        <cart-delivery v-if="this.isAuth && this.isActive"></cart-delivery>

        <cart-order v-if="this.isAuth && this.isActive"></cart-order>

        <div v-if="this.isAuth && !this.isActive" class="container page-title mt-4">
            <div class="row">
                <div class="block-title">Чтобы оформить заказ, ваш аккаунт должен быть активирован</div>
            </div>
            <div class="row">
                <div class="content mt-3">
                    <p>Размеры и наличие, реквизиты на оплату – все это станет доступно Вам после активации вашего
                        аккаунта нашими сотрудниками.</p>
                </div>
            </div>
        </div>

        <div v-if="!this.isAuth" class="container page-title mt-4">
            <div class="row">
                <div class="block-title">Чтобы оформить заказ, авторизуйтесь</div>
            </div>
            <div class="row">
                <div class="content mt-3">
                    <p>Избранное, корзина, история заказов, реквизиты на оплату –<br>
                        все это будет автоматически сохраняться и станет доступно Вам с любого устройства.</p>
                    <p>Также Вы получите накопительную скидку, растущую от сделанных ранее заказов.</p>
                </div>
            </div>
            <div class="row">
                <div class="inline_objects mt-4">
                    <a href="/login" class="btn btn-lg btn-regular btn-bi">Войти в кабинет</a>
                    <a href="/register" class="btn-outline-regular">Заявка на регистрацию</a>
                </div>
            </div>
        </div>
    </v-fragment>
</template>

<script>
export default {
    methods: {},
    computed: {
        isAuth() {
            return this.$store.state.isAuth;
        },
        isActive() {
            return this.$store.state.isActive;
        },
    },
};
</script>
